// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-child/kpi-child.less
// module id = 3464
// module chunks = 0